module.exports = __webpack_public_path__ + "img/zoombies_logo_horizontal_white_text_only.e0d83307.png";